import { currentPage, initNewSection } from '../common/layout';
import { goToUrl, banners } from '../common/utils/fn';
import '../common/msnt/msnt-lightslider.js';
import 'jquery-scrolltie';
import '../common/hammer';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';
import { getMakeModelFilter } from '../common/make-model-filter-loader';


currentPage.pageInit = ($page, pageData, pageId) => {
    getMakeModelFilter().then((api) => {
        api.makeModelFilter();
      });

    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });

    /*
    * show popup 
    */
    var popup = document.getElementById('popup-wrapper');
    var infoboxButton = document.getElementsByClassName('infobox')[0];

    if(infoboxButton) {
        infoboxButton.addEventListener('click', function() {
            showPopup();
        });    
    }

    function showPopup() {
      popup.style.display = 'block';
      document.body.style.overflow = 'hidden';

      window.onclick = function(event) {
        if (event.target == popup) {
          popup.style.display = 'none';
          document.body.style.overflow = 'auto';
        }
      };
    }
}

currentPage.pageLoadMore = ($html, $btnBox) => {
    //$btnBox.replaceWith($html);
    initNewSection($html)
    // hybridLazyLoad();
    banners($html);
    
    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });
}